import axios from 'axios'

// Same origin as the Django app (Vite proxies /api in dev). Session cookie + CSRF header handled by axios.
export const apiAxios = axios.create({
  baseURL: '/api/marketing',
  timeout: 60000,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
})
